
import React from 'react';
import { PrepaidCardEticketMobileDisplay } from '.';


import type { ETicketDisplay } from '../../../tsrestapi/models';

import TranslatorManager from 'ts-translate-js';
const tr = TranslatorManager.boundTR;

interface PrepaidCardEticketMobileDisplayListProps {
    eticketDisplays: ETicketDisplay[]
}

export function PrepaidCardEticketMobileDisplayList({ eticketDisplays }: PrepaidCardEticketMobileDisplayListProps) {
    let i = 1;
    let totalNumbering = eticketDisplays.length;

    let theme = eticketDisplays[0].PrepaidCardThemeName;
    const etickets = eticketDisplays.map(function(eticket){
        eticket.Numbering = i + "/" + totalNumbering;
        i = i + 1;
        return <PrepaidCardEticketMobileDisplay eticket={eticket} key={eticket.PassNumber} />;
    }.bind(this));

    //#region That's fucking disgusting, but we need to do this quickly now. Should be in a DB config.
    let headerMessage;
    if (eticketDisplays.length > 1)
        headerMessage = theme === "sam" ? tr("Vos chèques-cadeaux électroniques") : tr("Vos cartes cadeaux électroniques");
    else
        headerMessage = theme === "sam" ? tr("Votre chèque-cadeau électronique") : tr("Votre carte cadeau électronique");

    const footerMessage = theme === "sam" ? tr("Utilisez ce code lors du paiement pour échanger votre chèque-cadeau.") : tr("Utilisez ce code lors du paiement pour échanger votre carte cadeau.");
    //#endregion

    return <div className="container">
        <br/>
        <div className="row">
            <div className="eticketMobileWarning col-xs-12 col-sm-8 col-md-6 col-lg-6 col-sm-offset-2 col-md-offset-3">
                <div className="giftcard-header">{headerMessage}</div>
            </div>
        </div>
        <div className="row">
            <div className="col-xs-12">
                <div className={theme}>
                    <div className="giftcard-container">
                        {etickets}
                    </div>
                    <div className="giftcard-footer">
                        {footerMessage}
                    </div>
                </div>
            </div>
        </div>
    </div>;
}